import React, {  Component } from 'react';
import Form from 'react-bootstrap/Form';

class ItemResDef extends Component {

    constructor(props) {
        super(props);
        this.state = {
            itemDefId: props.itemDefId,
            domainName: props.domainName,
            picFilename: props.picFilename,
            audioFilename: props.audioFilename,
            videoFilename: props.videoFilename,
            docFilename: props.docFilename,
            url: props.url
        }
    }

    picChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, e.target.value, null, null, null, null)
        this.setState({ picFilename: e.target.value });
    }

    audioChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, null, e.target.value, null, null, null)
        this.setState({ audioFilename: e.target.value });
    }

    videoChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, null, null, e.target.value, null, null)
        this.setState({ videoFilename: e.target.value });
    }

    docChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, null, null, null, e.target.value, null)
        this.setState({ docFilename: e.target.value });
    }

    urlChangeHandler = (e) => {
        this.props.changeHandler(this.state.itemDefId, null, null, null, null, e.target.value)
        this.setState({ url: e.target.value });
    }
  

    render() {
        
        return (
            <tr>
                <td>{this.props.domainName}</td>
                <td>{this.props.assessmentArea}</td>
                
                <td>
                    <Form.Control 
                        type="text"
                        placeholder=""
                        defaultValue={this.state.picFilename}
                        onBlur={this.picChangeHandler}
                    />
                </td>
                <td>
                    <Form.Control
                        type="text"
                        placeholder=""
                        defaultValue={this.state.audioFilename}
                        onBlur={this.audioChangeHandler}
                    />
                </td>
                <td>
                    <Form.Control
                        type="text"
                        placeholder=""
                        defaultValue={this.state.videoFilename}
                        onBlur={this.videoChangeHandler}
                    />
                </td>
                <td>
                    <Form.Control
                        type="text"
                        placeholder=""
                        defaultValue={this.state.docFilename}
                        onBlur={this.docChangeHandler}
                    />
                </td>
                <td>
                    <Form.Control
                        type="text"
                        placeholder=""
                        defaultValue={this.state.url}
                        onBlur={this.urlChangeHandler}
                    />
                </td>
            </tr>  
        )
    }
}

export default ItemResDef;


// WEBPACK FOOTER //
// ./src/components/AdminHome/ItemResDef.js